import { render, staticRenderFns } from "./jumpSet.vue?vue&type=template&id=674dfcc2&scoped=true&"
import script from "./jumpSet.vue?vue&type=script&lang=js&"
export * from "./jumpSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674dfcc2",
  null
  
)

export default component.exports